import React, { useState, useEffect } from "react";
import Footer from "components/Layout/Footer";
import LayoutWrapper from "components/Layout/Wrapper";
import styled from "styled-components";
import { fetchInbox } from "app/datamodel/Inbox/api";
import fetch from "base/shared/fetch-data";
import mapToModel from "./mapToModel";
import { getAPIUrl } from "base/shared/Utils";
import envVars from "base/shared/Env";

const Container = styled.div`
  margin: 0px 382px;
  display: flex;
  flex-direction: column;
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const FlexHorizontal = styled.div`
  display: flex;
  flex-direction: row;
`;

const Img = styled.img`
  max-width: 200px;
  margin: 0 auto;
`;

const Column = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`;

const Header = styled.h1`
  width: 100%;
  margin-bottom: 30px;
`;

const PrevNextButton = styled.button`
  width: 30%;
`;

const PrevNextButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 20px;
`;

const model = {
  user: {
    name: "connection.other_user.first_name",
    picture: "connection.other_user.cover_picture.width_500_url",
    member_since: "user.metrics.member_since",
    last_active: "user.metrics.last_connection",
  },
  room: {
    title: "connection.room.title",
    price: "connection.room.monthly_price.price",
    currency: "connection.room.monthly_price.currency",
  },
};

const fetchUser = async (id, token) => {
  const { BADI_USER_SERVICE } = envVars();
  const serverUrl = getAPIUrl(BADI_USER_SERVICE.replace("{id}", id));

  return await fetch(serverUrl, { token });
};

const fetchData = async ({ token }) => {
  const result = await fetchInbox(
    { token },
    { category: "pending", page: 1, per: 30 },
  );
  return await Promise.all(
    result.data.connections.map(async (connection) => {
      const user = await fetchUser(connection.other_user.id, token);
      return mapToModel(model, { connection, user });
    }),
  );
};

const SwipingInbox = ({ token, isSwipingProfileCardsActive }) => {
  if (!isSwipingProfileCardsActive) {
    return null;
  }
  const [connections, setConnections] = useState([]);
  const [currentConnectionIndex, setCurrentConnectionIndex] = useState(0);
  useEffect(() => {
    fetchData({ token }).then((connections) => setConnections(connections));
  }, []);

  const nextRequest = () => {
    setCurrentConnectionIndex(
      (currentConnectionIndex + 1) % connections.length,
    );
  };
  const previousRequest = () => {
    const newIndex = currentConnectionIndex - 1;
    if (newIndex < 0) {
      setCurrentConnectionIndex(connections.length + newIndex);
    } else {
      setCurrentConnectionIndex(newIndex);
    }
  };
  const connection = connections[currentConnectionIndex];
  if (!connection) {
    return <div>Loading...</div>;
  }
  const { user, room } = connection;
  return (
    <LayoutWrapper footer={<Footer campaign="inbox_footer" />}>
      <Container>
        <Header>Inbox</Header>
        <PrevNextButtonContainer>
          <PrevNextButton onClick={previousRequest}>Previous</PrevNextButton>
          <PrevNextButton onClick={nextRequest}>Next</PrevNextButton>
        </PrevNextButtonContainer>
        <FlexHorizontal>
          <Column>
            <Nav>
              <div>Requests</div>
              <div>Chats</div>
            </Nav>
            <Img src={user.picture} alt="user image" />
            <h3>{user.name}</h3>
            <div>Member since: {user.member_since}</div>
            <div>Last active: {user.last_active}</div>
          </Column>
          <Column>
            <h3>Room requested</h3>
            <b>{room.title}</b>
            <p>Carrer de Margarit, Barcelona, Spain</p>
            <p>Available from 01/01/2022</p>
            <p>Minimum stay 1 month</p>
            <p>
              Monthly price: {room.price} {room.currency}
            </p>
          </Column>
        </FlexHorizontal>
      </Container>
    </LayoutWrapper>
  );
};

export default SwipingInbox;
